<template>
  <v-menu>
    <template #activator="{ props }">
      <StandardButton
        v-bind="props"
        :text="selectedLocale"
        :text-translate="false"
        append-icon="expand_more"
        aria-label="Change language"
        color="black"
        prepend-icon="language"
        variant="text"
        language-select
      />
    </template>

    <v-list
      :selected="selectedLanguage"
      density="compact"
      elevation="0"
      border
    >
      <v-list-item
        v-for="(lang, index) in store.state.languages"
        @click="switchLocale(lang.value)"
        :key="index"
        :value="lang"
        color="primary"
      >
        <v-list-item-title
          :id="'i18n_link_' + lang.value"
          :aria-label="getAriaLabel(lang.text)"
          tracked
        >
          {{ lang.text }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

import assets from '@/shared/services/assets';
import useApi from '@/shared/composables/useApi';
import useLocaleLoader from '@/shared/composables/useLocaleLoader';

const { api } = useApi();
const i18n = useI18n();
const store = useStore();
const $bct = inject('translator');
const { fetchedLocales, switchLocale: loadAndSetLocale } = useLocaleLoader();

const selectedLanguage = computed(() => {
  const value = i18n.locale.value.split('-')[0];
  const lang = store.state.languages.find((language) => language.value === value);
  return [lang];
});

const selectedLocale = computed(() => {
  const value = i18n.locale.value.split('-')[0];
  const lang = assets.assets.locales.find((locale) => locale.value === value);
  if (!fetchedLocales.value.includes(value)) {
    void switchLocale(value);
  }

  return lang.title || lang.text;
});

function getAriaLabel(text) {
  return `${$bct('Change language')}, ${text}`;
}

async function switchLocale(lang) {
  await loadAndSetLocale(lang);

  if (store.state.profile) {
    let response;
    if (store.state.role === 'manager') {
      response = await api.manager.profile.updateSelf({ body: { default_locale: lang } });
    } else {
      response = await api.member.profile.update({ default_locale: lang });
    }
    if (response) store.commit('setProfile', response.data);
  }
}
</script>
